// extracted by mini-css-extract-plugin
module.exports = {"unavailable":"_f40933c"};